import SSO from '../../spa/sso/SSO';


const UsuarioForm = () => import('../../spa/sso/usuario/UsuarioForm');
const UsuarioList = () => import('../../spa/sso/usuario/UsuarioList');

export default {
  path: 'sso-usuario',
  component: SSO,
  children: [
    {
      path: '',
      name: 'sso-usuario',
      component: UsuarioList,
    },
    {
      path: 'novo',
      name: 'novoUsuarioSSO',
      component: UsuarioForm,
    },
    {
      path: ':id/editar',
      name: 'editarUsuarioSSO',
      component: UsuarioForm,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/sso-usuario.js